export class UserBranchRequestModel {
  appUserBranchId: number;
  appUserId: number;
  crmBranchId: number;
  isActive: boolean;
  modifiedByUserInfoId: number;
  dateTimeCreated: Date;
  dateTimeLastModified: Date;
}
